import React, { useState } from 'react';
import { Block } from "@randajan/jet-react/dom/block";

import "./InitScreen.scss";
import { Button, Field, Form, Switch } from '@randajan/jet-react/dom/form';
import { useBeam } from '@randajan/bifrost/client/react';
import { Link } from "@randajan/jet-react/dom/link";

import { docsBeam, shopBeam, userBeam, varsBeam } from '../../../config/bifrost';

import { page } from "@randajan/jet-react/base/page";
import { LogoutButton } from '../LogoutButton/LogoutButton';

export const InitScreen = (props) => {
    const { data: user } = useBeam(userBeam);
    const { data: docsList } = useBeam(docsBeam);

    const [step, setStep] = useState(0);

    const docs = Object.fromEntries((docsList || []).map(doc => [doc.id, doc]));

    const submit = (btn, consentNotify = false) => {
        const { parent } = btn.props;
        return userBeam.act.consent({ ...parent.getOutput(), consentNotify });
    }

    return (
        <section className="InitScreen">
            <div className="scene" data-step={step}>
                <Block level={0} className="consentTerms popScreen" caption="Vítej!">
                    <span>Je pro mě důležité, aby tvé kroky byly vědomé, a proto nám prosím věnuj ještě malý okamžik.</span>
                    <ul>
                        <li>Doporučujeme převážně <b>dámskou módu</b>.</li>
                        <li>Nové tipy přidáváme každý týden.</li>
                        <li>Přístup k obsahu získáš na základě platného členství.</li>
                        <li>Hromadné sdílení obsahu tohoto webu je přísně zakázáno.</li>
                        <li>Uvádění nepravdivých osobních informací může vést k blokaci účtu.</li>
                        <li>Děláme maximum, ale za zboží a služby třetích stran neneseme odpovědnost.</li>
                    </ul>
                    <Button onSubmit={_ => page.set("search.cti", docs?.terms?.webPath)}>{docs?.terms?.name}</Button>
                    <span>Souhlasíš s podmínkami v plném znění?</span>
                    <div className="buttons">
                        <Button className="accept" onSubmit={_ => setStep(1)}>Souhlasím</Button>
                        <LogoutButton>Nesouhlasím - odhlásit se</LogoutButton>
                    </div>
                </Block>
                <Block level={0} className="consentGdpr popScreen" caption="Souhlas se zpracováním údajů dle GDPR">
                    <span>Abychom ti mohli poskytnout službu, potřebujeme tvůj souhlas se zpracováním údajů.</span>
                    <span>Kliknutím zde si můžeš přečíst, jak zacházíme s tvými daty:</span>
                    <Button onSubmit={_ => page.set("search.cti", docs?.privacy?.webPath)}>{docs?.privacy?.name}</Button>
                    <span>Můžeme tvé údaje zpracovávat podle zásad GDPR?</span>
                    <div className="buttons">
                        <Button className="accept" onSubmit={_ => setStep(2)}>Souhlasím</Button>
                        <LogoutButton>Nesouhlasím - odhlásit se</LogoutButton>
                    </div>
                </Block>
                <Block level={0} className="consentNotify popScreen" caption="Jaká oznámení odesíláme?">
                    <ul>
                        <li>Uvítací zprávu</li>
                        <li>Potvrzení o přijaté platbě</li>
                        <li>Oznámení o nových produktech v nabídce</li>
                        <li>Upozornění na konec členství</li>
                    </ul>
                    <Form rawput={user}>
                        <span>Zkontroluj prosím, že máme správně tvoje údaje:</span>
                        <Field name="name" label={"Jméno a příjmení"} autoSize/>
                        <Field name="email" label={"E-mail"} autoSize/>
                        <div className="buttons">
                            <Button className="accept" onSubmit={btn => submit(btn, true)}>Chci oznámení</Button>
                            <Button onSubmit={btn => submit(btn, false)}>Nechci oznámení</Button>
                        </div>
                    </Form>
                </Block>
            </div>
        </section>
    )
}

